export default __webpack_public_path__ + "static/media/ice.97ddede4.svg";